import axios from 'axios'
import {
  errorInterceptor,
  requestInterceptor,
  successInterceptor
} from './interceptors'
import { isSecureLinkPage } from './api.utils'
import configs from 'config/environment'
import {
  clearAuthTokens,
  getRefreshToken,
  setAuthTokens
} from '../auth/tokenStorage'

const axiosRequestConfig = {
  baseURL: configs.apiUrl,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json'
  }
}

const api = axios.create(axiosRequestConfig)

api.interceptors.request.use(requestInterceptor)
api.interceptors.response.use(successInterceptor, errorInterceptor)

let refreshPromise = null

const performTokenRefresh = async () => {
  const storedRefreshToken = getRefreshToken()
  if (!storedRefreshToken) {
    console.warn('No refresh token available in localStorage')
    throw new Error('No refresh token available')
  }

  const response = await api.post('/Api/V8/custom/portal/refresh-token', {
    refresh_token: storedRefreshToken
  })

  const data = response.data

  if (!data?.access_token) {
    console.warn(
      'Token refresh response missing access_token — expected fields not present',
      data
    )
    throw new Error('Failed to refresh token')
  }

  if (!data?.refresh_token) {
    console.warn(
      'Token refresh response missing refresh_token (rotation risk) — expected fields not present',
      data
    )
  }

  setAuthTokens(data)
  return data
}

const requestTokenRefresh = () => {
  if (!refreshPromise) {
    refreshPromise = performTokenRefresh().finally(() => {
      refreshPromise = null
    })
  }
  return refreshPromise
}

const isTokenRefreshInFlight = () => Boolean(refreshPromise)

const refreshToken = async () => {
  try {
    const data = await requestTokenRefresh()
    return data.access_token
  } catch (error) {
    console.error('Token refresh failed:', error)
    if (
      error.response?.status === 401 ||
      error.message === 'No refresh token available'
    ) {
      clearAuthTokens()
    }
    if (!isSecureLinkPage()) {
      window.location.href = '/login'
    }
    throw error
  }
}

export default {
  delete: api.delete,
  get: api.get,
  patch: api.patch,
  post: api.post,
  put: api.put,
  refreshToken,
  requestTokenRefresh,
  isTokenRefreshInFlight
}
